import { checkColor } from '@app/utils';
import { Platform, StyleSheet } from 'react-native';
export const ls = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderWidth: 1,
    backgroundColor: 'rgb(255, 255, 255)',
    borderColor: 'rgb(152, 162, 179)',
    borderRadius: 4,
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginTop: 8,
    height: 48,
    width: '100%',
  },
  input: {
    placeholderTextColor: '#9395A4',
    fontSize: 16,
    fontFfamily: 'Inter',
    fontWeight: '400',
    flexDirection: 'row',
    width: '100%',
    padding: 0,
    justifyContent: 'center',
    outlineStyle: 'none',
    color: 'rgb(29, 41, 57)',
    flex : 1,
  },
  labelContainer: {
    position: 'absolute',
  },
  label: {
    fontFamily: 'Inter',
    fontWeight: '400',
    color: '#98a2b3',
    fontSize: 16,
  },
  labelNonAnimated: {
    fontFamily: 'Inter',
    fontWeight: '400',
    color: '#98a2b3',
    fontSize: 12,
    textTransform: 'none',
    padding: 0,
    marginTop : 12,
  },
  inputFocused: {
    borderColor: checkColor('rgb(20, 52, 203)'),
  },
  inputError: {
    borderColor: 'rgb(240, 68, 56)',
    color: 'rgb(205, 46, 53)',
  },
  errorMessage: {
    color: 'rgb(240, 68, 56)',
    fontFamily: 'Inter',
    fontSize: 12,
  },
});
